import {
  ERROR_MESSAGE_SHOWN,
  CONTINUE_ERROR_SHOWN,
} from 'src/app/constants/errorMessages';
import {
  CAJA_FLOW_TYPE_COPY,
  CAJA_FLOW_TYPE_CREATE,
  CAJA_FLOW_TYPE_DRAFT,
} from 'src/app/constants/tealium';
import type { Tealium } from 'src/types/appState';

import sendLinkEvent from './sendLinkEvent';

export const LINK_NAME_ERROR = 'proceed-error-shown';
export const ERROR_VIEWED = 'error_viewed';

export default (tealium: Tealium, errorMessage: string) => {
  const createFlowEventData = {
    linkName: LINK_NAME_ERROR,
    eventName: [LINK_NAME_ERROR, ERROR_MESSAGE_SHOWN, CONTINUE_ERROR_SHOWN],
    errorMessage,
  };

  const editOrRefreshFlowEventData = {
    linkName: ERROR_VIEWED,
    eventName: [ERROR_VIEWED],
    errorMessage,
  };

  const isCreateFlow =
    tealium.cajaFlowType === CAJA_FLOW_TYPE_COPY ||
    tealium.cajaFlowType === CAJA_FLOW_TYPE_CREATE ||
    tealium.cajaFlowType === CAJA_FLOW_TYPE_DRAFT;

  const eventData = isCreateFlow
    ? createFlowEventData
    : editOrRefreshFlowEventData;

  sendLinkEvent(tealium, eventData);
};
